<template>
  <div class="tab-six-cv">
    <div>
      <el-alert title="" type="error">
        <template slot="title">
          <p>文书RP需要学生先上传中文RP文书版本，我们会根据该文书上传英文RP文书版本</p>
        </template>
      </el-alert>
      <el-form class="form-wrapper" label-width="80px">
        <el-button size="small" type="primary" @click="addDocumentRP"
        >新增RP</el-button
        >
        <el-form-item label="状态">
          <el-select
            v-model="local_filter_state"
            multiple
            collapse-tags
            placeholder="请选择(支持多选)"
          >
            <el-option
              v-for="item in kStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button
          @click="filterAction"
          style="margin-left: 10px"
          type="primary"
        >筛选</el-button
        >
      </el-form>

      <el-table v-loading="loading" :data="lists" style="width: 100%">
        <el-table-column prop="d1" label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{
              (requestData.page - 1) * requestData.paginate + (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column label="文书" prop="" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.name">
              <el-link
                type="primary"
                @click="
                  () => {
                    previewUrl = scope.row.upload_documents[0].url;
                    previewName = scope.row.upload_documents[0].name;
                  }
                "
              >
                预览/下载
              </el-link>
              <p v-if="scope.row.document_status == 1" style="color: red;margin: 0"
              >[终稿]</p
              >
              <p v-if="scope.row.document_status == 2" style="color: red;margin: 0"
              >[草稿,请勿确认]</p
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="上传者" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.name">{{
                scope.row.upload_documents[0].operator_name
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文书记录" prop="" align="center">
          <template slot-scope="scope">
            <el-link type="primary" @click="logDocumentRP(scope.row)"
            >查看</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 'rp' " style="color: #08a0ee">老师上传</p>
            <p v-if="scope.row.type == 'rpu' " style="color: #08a0ee">学生上传</p>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" sortable>
          <template slot-scope="scope">
            <p v-if="scope.row.status == 3" style="color: red">待确认</p>
            <p v-if="scope.row.status == 1" style="color: #08a0eeff">已确认</p>
            <el-link
              v-if="scope.row.status == 2  && scope.row.type == 'rp'"
              type="danger"
              @click="showDetailDialogContent(scope.row.content,scope.row.reject_type)"
            >已驳回，待老师修改</el-link
            >
            <el-link
              v-if="scope.row.status == 2 && scope.row.type == 'rpu'"
              type="danger"
              @click="showDetailDialogContent(scope.row.content,scope.row.reject_type)"
            >被驳回待修改，查看原因</el-link
            >
            <p v-if="scope.row.status == 0" style="color: red">待老师上传</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="" align="center" width="120">
          <template slot-scope="scope">
            <div class="btns-wrapper" v-if="scope.row.type != 'rpu'">
              <el-popconfirm
                class="btn"
                title="是否确认？"
                @confirm="updateStatus(scope.row.id, 1)"
                v-if="scope.row.status == 3"
              >
                <el-button slot="reference" size="mini" type="primary"
                >确认</el-button
                >
              </el-popconfirm>
              <div class="btn" v-if="scope.row.status == 3">
                <el-button
                  size="mini"
                  type="danger"
                  class="btn"
                  @click="refuseUserSchoolChoice(scope.row.id)"
                >驳回</el-button
                >
              </div>
            </div>

            <div class="btns-wrapper" v-if="scope.row.type == 'rpu'">

              <el-button
                class="btn"
                v-if="
                  scope.row.status == 3 ||
                  scope.row.status == 2 ||
                  scope.row.status == 1
                "
                size="mini"
                @click="editDocumentRP(scope.row)"
                type="primary"
              >修改</el-button
              >
              <el-popconfirm
                title="是否确定删除该数据？"
                @confirm="delDocumentRP(scope.row.id)"
              >
                <el-button
                  class="btn"
                  slot="reference"
                  size="mini"
                  type="danger"
                  v-if="scope.row.status == 3 || scope.row.status == 2"
                >删除</el-button
                >
              </el-popconfirm>
            </div>


          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" align="center" />
      </el-table>
    </div>

    <!--文书上传弹窗-->
    <show_document  ref="showDocument" />
    <!--文书显示弹窗-->
    <upload_document ref="uploadDocument" @show_list="getList" />
    <reject ref="reject" @reject="getList" :needFile="true"></reject>
    <reason_rejection ref="reason_rejection"></reason_rejection>
    <HBFilePreview
      buttonType="document"
      :previewUrl="previewUrl"
      :fileName="previewName"
      @updateVisible="
        previewUrl = null;
        previewName = null;
      "
    />
    <el-dialog
      center
      title="查看"
      :visible="detailInfoDialog"
      width="50%"
      :before-close="() => (detailInfoDialog = null)"
    >
      <p style="white-space: pre-wrap; font-size: 16px">
        {{ detailInfoDialog }}
      </p>
    </el-dialog>
  </div>
</template>
<script>
import {
  document_list,
  del_document,
  user_information_document_edit,
} from "@/api/mycenter_studyabroad";
import { downloadFile } from "@/api/file";
import show_document from "./show_document";
import upload_document from "./upload_document";
import reject from "./reject";
import reason_rejection from "./reason_rejection.vue";
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview.vue";
export default {
  name: "TabSixCv",
  components: {
    reject,
    reason_rejection,
    show_document,
    upload_document,
    HBFilePreview,
  },
  data() {
    return {
      loading: '',
      local_filter_state: [],
      detailInfoDialog: null,
      previewUrl: null,
      previewName: null,
      infoListDialogDataSource: [],
      dialogAddUserSchoolChoice: false,
      dataSource: [],
      lists: [], // 数据列表
      page: {
        total: 100000, // 总条数
        currentPage: 1
      },
      addUserSchoolChoiceData: {
        remark: ''
      },
      reject_url: '',
      addMessage: {
        id: '',
        content: ''
      },
      TaskMessageVisible: false,
      requestData: {
        page: 1, // 当前页
        paginate: 15, // 分页大小
        templates_id: '',
        type: 'rp',
        loading: ''
      },
      content: {
        title: '',
        type: '',
        name: '',
        operate: '',
        id: ''
      }
    };
  },
  computed: {
    kStateOptions() {
      return [
        {
          label: "已驳回",
          value: 2,
        },
        {
          label: "待确认",
          value: 3,
        },
        {
          label: "已确认",
          value: 1,
        },
        {
          label: "待老师上传",
          value: 0,
        },
      ];
    },
  },
  created() {
    this.getList(true);
  },
  methods: {

    editDocumentRP(content) {
      this.content.type = "rpu";
      this.content.id = content.id;
      this.content.name = content.name.substring(0, content.name.indexOf("-"));
      this.content.operate = "edit";
      this.content.title = "修改rp";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    addDocumentRP() {
      this.content.type = "rpu";
      this.content.operate = "add";
      this.content.title = "添加rp";
      this.content.id = "";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    delDocumentRP(id) {
      del_document({ id: id, type: "rpu" }).then((response) => {
        this.getList(true);
      });
    },
    updateStatus(id,status) {
      user_information_document_edit({ 'id': id, 'status': status, 'type': 'rp' }).then(()=> {
        this.$message.success('状态更新成功')
        this.getList(true)
      }).catch(error=> {
        this.$message.error(error.message)
      })
    },
    refuseUserSchoolChoice(id) {
      this.$refs.reject.sendItem(id, "rp", 2);
    },
    filterAction() {
      if (!this.local_filter_state || this.local_filter_state.length == 0) {
        this.lists = this.dataSource;
        return;
      }
      const resultList = [];
      const stateList = this.local_filter_state || [];

      this.dataSource.forEach((item) => {
        var flag = true;

        if (stateList.length > 0 && !stateList.includes(item.status)) {
          flag = false;
        }
        if (flag == true) {
          resultList.push(item);
        }
      });
      this.lists = resultList;
    },
    downLoad(url, name) {
      downloadFile(url, name);
    },
    showDetailDialogContent(content,reject_type) {
      // var con = JSON.parse(item);
      // this.reject_url = con.url;
      // var str = con.content;
      // if(reject_type){
      //   str = reject_type + ' | ' + str
      // }
      // this.infoListDialogDataSource = [
      //   { label: "驳回原因", content: str },
      // ];
      content = JSON.parse(content);
      this.$refs.reason_rejection.sendItem(content.content, content.url,reject_type);

    },
    getList(isRefresh) {
      // // 获取列表
      // if (isRefresh) {
      //   this.requestData.page = 1
      // }
      this.loading = true;
      document_list(this.requestData).then((response) => {
        this.loading = false;
        const dataList = response.data || [];
        this.dataSource = dataList;
        this.lists = dataList;
        this.filterAction();
      });
    },
    logDocumentRP(content) {
      this.$refs.showDocument.sendItem(content.upload_documents);
    },

  },
};
</script>
<style lang="scss" scoped>
.tab-six-cv {
  .form-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .btn {
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_six_rp.vue